export function getCustomFolderListItemProps(value) {
  return {
    text: value.display_name,
  }
}
